var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flight-row" },
    [
      _c(
        "v-row",
        { staticClass: "flight-divider" },
        [
          _c("v-col", { attrs: { cols: "8" } }, [
            _c(
              "span",
              {
                staticClass:
                  "white px-2 ml-12 primary--text flight-divider-text"
              },
              [_vm._v(" " + _vm._s(_vm.contextLabel) + " ")]
            )
          ]),
          _c("v-col", { attrs: { cols: "2" } }, [
            _vm.transfers > 0
              ? _c("span", { staticClass: "white px-2 grey--text" }, [
                  _vm._v(" " + _vm._s(_vm.transfersText) + " ")
                ])
              : _vm._e()
          ]),
          _c("v-spacer"),
          _c(
            "v-col",
            { staticClass: "text-right primary--text", attrs: { cols: "2" } },
            [
              _c("span", { staticClass: "white px-4 mr-10" }, [
                _vm._v(" " + _vm._s(_vm.travelTime) + " ")
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "text-md-right", attrs: { cols: "12", md: "4" } },
            [
              _c(
                "div",
                { staticClass: "flight-content" },
                [
                  _c(
                    "span",
                    { staticClass: "flight-content-airport-code accent--text" },
                    [_vm._v(_vm._s(_vm.start_airport_code))]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { color: "white", bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "span",
                                _vm._g(
                                  { staticClass: "flight-content-time" },
                                  on
                                ),
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.start_time != null
                                        ? _vm.start_time.substr(0, 5)
                                        : _vm.$t("global.noData")
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("span", { staticStyle: { color: "#0f0f0f" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.start_time != null
                              ? _vm.start_time.substr(0, 5)
                              : _vm.$t("global.noData")
                          ) +
                            " " +
                            _vm._s(
                              _vm.start_date != null
                                ? _vm.dayOfWeek(_vm.start_date) +
                                    " " +
                                    _vm.formatDateView(_vm.start_date)
                                : _vm.$t("global.noData")
                            )
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "flight-content-airport-name" }, [
                _vm._v(_vm._s(_vm.start_airport_name))
              ])
            ]
          ),
          _c(
            "v-col",
            { staticClass: "text-center px-4", attrs: { cols: "12", md: "4" } },
            [
              _c("v-icon", { attrs: { "x-large": "" } }, [
                _vm._v("flight_takeoff")
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "400px",
                    "max-width": "calc(100% - 90px)",
                    padding: "0 10px"
                  }
                },
                [
                  _c("div"),
                  _c("v-divider", { staticClass: "route-line" }),
                  _c("div", { staticClass: "dot-container" }, [
                    _vm.transfers > 0
                      ? _c(
                          "div",
                          _vm._l(parseInt(_vm.transfers), function(i) {
                            return _c("div", { key: i, staticClass: "dot" })
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "grey--text" }, [
                    _vm.transfers > 0
                      ? _c("span", [
                          _vm._v(" " + _vm._s(_vm.transfersText) + " ")
                        ])
                      : _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("booking.direct")) + " ")
                        ])
                  ])
                ],
                1
              ),
              _c("v-icon", { attrs: { "x-large": "" } }, [
                _vm._v("flight_land")
              ])
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "text-md-left", attrs: { cols: "12", md: "4" } },
            [
              _c(
                "div",
                { staticClass: "flight-content" },
                [
                  _c(
                    "span",
                    { staticClass: "flight-content-airport-code accent--text" },
                    [_vm._v(_vm._s(_vm.end_airport_code))]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { color: "white", bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "span",
                                _vm._g(
                                  { staticClass: "flight-content-time" },
                                  on
                                ),
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.end_time != null
                                        ? _vm.end_time.substr(0, 5)
                                        : _vm.$t("global.noData")
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("span", { staticStyle: { color: "#0f0f0f" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.end_time != null
                              ? _vm.end_time.substr(0, 5)
                              : _vm.$t("global.noData")
                          ) +
                            " " +
                            _vm._s(
                              _vm.end_date != null
                                ? _vm.dayOfWeek(_vm.end_date) +
                                    " " +
                                    _vm.formatDateView(_vm.end_date)
                                : _vm.$t("global.noData")
                            )
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "flight-content-airport-name" }, [
                _vm._v(_vm._s(_vm.end_airport_name))
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }